/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchDeletePackageTemplateRequest,
    BatchDeletePackageTemplateResponse,
    CreatePackageTemplateRequest,
    GetPackageTemplateResponse,
    GetPackageTemplateUnitResponse,
    IdResponse,
    PatchPackageTemplateRequest,
    PatchPackageTemplateUnitRequest,
} from '../models';

export interface StorePackageTemplateApiControllerBatchDeleteRequest {
    storeId: string;
    batchDeletePackageTemplateRequest: BatchDeletePackageTemplateRequest;
}

export interface StorePackageTemplateApiControllerCreateRequest {
    storeId: string;
    createPackageTemplateRequest: CreatePackageTemplateRequest;
}

export interface StorePackageTemplateApiControllerDeleteRequest {
    storeId: string;
    packageTemplateId: string;
}

export interface StorePackageTemplateApiControllerGetRequest {
    storeId: string;
}

export interface StorePackageTemplateApiControllerGetPackageTemplateUnitRequest {
    storeId: string;
}

export interface StorePackageTemplateApiControllerPatchRequest {
    storeId: string;
    packageTemplateId: string;
    patchPackageTemplateRequest: PatchPackageTemplateRequest;
}

export interface StorePackageTemplateApiControllerPatchPackageTemplateUnitRequest {
    storeId: string;
    patchPackageTemplateUnitRequest: PatchPackageTemplateUnitRequest;
}

/**
 * 
 */
export class StorePackageTemplateApi extends runtime.BaseAPI {

    /**
     */
    async storePackageTemplateApiControllerBatchDeleteRaw(requestParameters: StorePackageTemplateApiControllerBatchDeleteRequest): Promise<runtime.ApiResponse<BatchDeletePackageTemplateResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storePackageTemplateApiControllerBatchDelete.');
        }

        if (requestParameters.batchDeletePackageTemplateRequest === null || requestParameters.batchDeletePackageTemplateRequest === undefined) {
            throw new runtime.RequiredError('batchDeletePackageTemplateRequest','Required parameter requestParameters.batchDeletePackageTemplateRequest was null or undefined when calling storePackageTemplateApiControllerBatchDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/package-templates:batchDelete`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchDeletePackageTemplateRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storePackageTemplateApiControllerBatchDelete(requestParameters: StorePackageTemplateApiControllerBatchDeleteRequest): Promise<BatchDeletePackageTemplateResponse> {
        const response = await this.storePackageTemplateApiControllerBatchDeleteRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storePackageTemplateApiControllerCreateRaw(requestParameters: StorePackageTemplateApiControllerCreateRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storePackageTemplateApiControllerCreate.');
        }

        if (requestParameters.createPackageTemplateRequest === null || requestParameters.createPackageTemplateRequest === undefined) {
            throw new runtime.RequiredError('createPackageTemplateRequest','Required parameter requestParameters.createPackageTemplateRequest was null or undefined when calling storePackageTemplateApiControllerCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/package-templates`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createPackageTemplateRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storePackageTemplateApiControllerCreate(requestParameters: StorePackageTemplateApiControllerCreateRequest): Promise<IdResponse> {
        const response = await this.storePackageTemplateApiControllerCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storePackageTemplateApiControllerDeleteRaw(requestParameters: StorePackageTemplateApiControllerDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storePackageTemplateApiControllerDelete.');
        }

        if (requestParameters.packageTemplateId === null || requestParameters.packageTemplateId === undefined) {
            throw new runtime.RequiredError('packageTemplateId','Required parameter requestParameters.packageTemplateId was null or undefined when calling storePackageTemplateApiControllerDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/package-templates/{packageTemplateId}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"packageTemplateId"}}`, encodeURIComponent(String(requestParameters.packageTemplateId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storePackageTemplateApiControllerDelete(requestParameters: StorePackageTemplateApiControllerDeleteRequest): Promise<void> {
        await this.storePackageTemplateApiControllerDeleteRaw(requestParameters);
    }

    /**
     */
    async storePackageTemplateApiControllerGetRaw(requestParameters: StorePackageTemplateApiControllerGetRequest): Promise<runtime.ApiResponse<Array<GetPackageTemplateResponse>>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storePackageTemplateApiControllerGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/package-templates`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storePackageTemplateApiControllerGet(requestParameters: StorePackageTemplateApiControllerGetRequest): Promise<Array<GetPackageTemplateResponse>> {
        const response = await this.storePackageTemplateApiControllerGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storePackageTemplateApiControllerGetPackageTemplateUnitRaw(requestParameters: StorePackageTemplateApiControllerGetPackageTemplateUnitRequest): Promise<runtime.ApiResponse<GetPackageTemplateUnitResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storePackageTemplateApiControllerGetPackageTemplateUnit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/package-template-unit`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storePackageTemplateApiControllerGetPackageTemplateUnit(requestParameters: StorePackageTemplateApiControllerGetPackageTemplateUnitRequest): Promise<GetPackageTemplateUnitResponse> {
        const response = await this.storePackageTemplateApiControllerGetPackageTemplateUnitRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storePackageTemplateApiControllerPatchRaw(requestParameters: StorePackageTemplateApiControllerPatchRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storePackageTemplateApiControllerPatch.');
        }

        if (requestParameters.packageTemplateId === null || requestParameters.packageTemplateId === undefined) {
            throw new runtime.RequiredError('packageTemplateId','Required parameter requestParameters.packageTemplateId was null or undefined when calling storePackageTemplateApiControllerPatch.');
        }

        if (requestParameters.patchPackageTemplateRequest === null || requestParameters.patchPackageTemplateRequest === undefined) {
            throw new runtime.RequiredError('patchPackageTemplateRequest','Required parameter requestParameters.patchPackageTemplateRequest was null or undefined when calling storePackageTemplateApiControllerPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/package-templates/{packageTemplateId}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"packageTemplateId"}}`, encodeURIComponent(String(requestParameters.packageTemplateId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchPackageTemplateRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storePackageTemplateApiControllerPatch(requestParameters: StorePackageTemplateApiControllerPatchRequest): Promise<void> {
        await this.storePackageTemplateApiControllerPatchRaw(requestParameters);
    }

    /**
     */
    async storePackageTemplateApiControllerPatchPackageTemplateUnitRaw(requestParameters: StorePackageTemplateApiControllerPatchPackageTemplateUnitRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storePackageTemplateApiControllerPatchPackageTemplateUnit.');
        }

        if (requestParameters.patchPackageTemplateUnitRequest === null || requestParameters.patchPackageTemplateUnitRequest === undefined) {
            throw new runtime.RequiredError('patchPackageTemplateUnitRequest','Required parameter requestParameters.patchPackageTemplateUnitRequest was null or undefined when calling storePackageTemplateApiControllerPatchPackageTemplateUnit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/package-template-unit`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchPackageTemplateUnitRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storePackageTemplateApiControllerPatchPackageTemplateUnit(requestParameters: StorePackageTemplateApiControllerPatchPackageTemplateUnitRequest): Promise<void> {
        await this.storePackageTemplateApiControllerPatchPackageTemplateUnitRaw(requestParameters);
    }

}
